import angular from "angular";
import ConfigService from "app/services/ConfigService";
import LocaleService from "app/services/LocaleService";
import toastr from "angular-toastr";

export default angular.module("services.DemoMode",[ConfigService,LocaleService,toastr]).factory("DemoModeService",
  ["ConfigService", "LocaleService", "toastr",
  function DemoModeService(ConfigService, LocaleService, toastr) {

  var demoMode = false;
  var toast;

  function isDemoModeEnabled() {
    return demoMode;
  }

  function enableDemoMode() {
    demoMode = true;
    toast = toastr.success(LocaleService.get("demoData.enabled"));
  }

  function disableDemoMode() {
    demoMode = false;
    toast = toastr.success(LocaleService.get("demoData.disabled"));
  }

  function toggleDemoMode() {
    toastr.clear(toast);
    if (isDemoModeEnabled()) {
      disableDemoMode();
    }
    else {
      enableDemoMode();
    }
  }

  function setDemoMode(value) {
    if (value) {
      enableDemoMode();
    }
    else {
      disableDemoMode();
    }
  }

  return {
    toggleDemoMode: toggleDemoMode,
    disableDemoMode: disableDemoMode,
    enableDemoMode: enableDemoMode,
    isDemoModeEnabled: isDemoModeEnabled,
    setDemoMode: setDemoMode
  };
}]).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/DemoModeService.js